import { useDispatch, useSelector } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';

import { sageHomeApi } from './sageHomeApi';
import authReducer from './slices/authSlice';
import careNeedsReducer from './slices/careInstructionsSlice';
import onboardingReducer from './slices/onboardingSlice';
import teamMemberReducer from './slices/teamMemberSlice';
import uiReducer from './slices/uiSlice';

const store = configureStore({
    reducer: {
        [sageHomeApi.reducerPath]: sageHomeApi.reducer,
        auth: authReducer,
        careNeeds: careNeedsReducer,
        ui: uiReducer,
        teamMember: teamMemberReducer,
        onboarding: onboardingReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }).concat(sageHomeApi.middleware),
    devTools: !import.meta.env.PROD,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
